import { createTheme } from "@mui/material/styles";

const DEFAULT_PRIMARY = "#0958d7";
const DEFAULT_SECONDARY = "#0380fe";

export const createAppTheme = () => {
  const primary =
    (typeof window !== "undefined" && window.__THEME_PRIMARY__) ||
    localStorage.getItem("theme_primary") ||
    DEFAULT_PRIMARY;

  const secondary =
    (typeof window !== "undefined" && window.__THEME_SECONDARY__) ||
    localStorage.getItem("theme_secondary") ||
    DEFAULT_SECONDARY;

  return createTheme({
    palette: {
      primary: { main: primary },
      secondary: { main: secondary },
    },
    typography: { fontFamily: "Arial, sans-serif" },
  });
};

export default createAppTheme();
